module.exports = __webpack_public_path__ + "static/img_2154-3ba6a7d6b4a99f266b7b8eb58ed51846.webp";